import React, { lazy, useEffect } from 'react';

import { Route, Switch, Redirect } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
import Suspense from '../../../ui-components/suspense';

/* Pages */
const TermsOfUse = lazy(() => import('../../legalpages/termsofuse'));
const PrivacyPolicy = lazy(() => import('../../legalpages/privacypolicy'));
const CustomerAgreement = lazy(() => import('../../legalpages/customeragreement'));
const DataFormat = lazy(() => import('../../legalpages/dataformat'));
const AboutUs = lazy(() => import('./aboutus'));
const Home = lazy(() => import('./home'));
const GCOwner = lazy(() => import('./gc-owner'));
const GCSelfPerform = lazy(() => import('./gc-self-perform'));
const TradeContractor = lazy(() => import('./trade-contractor'));
const Suppliers = lazy(() => import('./suppliers'));
const SmallBusiness = lazy(() => import('./small-business'));
const Pricing = lazy(() => import('./pricing'));
const Tutorials = lazy(() => import('./tutorials'));
const Contact = lazy(() => import('./contact'));
const QuickStart = lazy(() => import('./gc-quickstart'));
const Concrete = lazy(() => import('./landing/div-03-concrete'));
const Masonry = lazy(() => import('./landing/div-04-masonry'));
const BuildingFraming = lazy(() => import('./landing/div-06-building-framing'));
const RoofingInsulation = lazy(() => import('./landing/div-07-roofing-insulation'));
const InteriorSpecialty = lazy(() => import('./landing/div-09-interior-specialty'));
const Mechanical = lazy(() => import('./landing/div-23-mechanical'));
const SubmittalTemplates = lazy(() => import('./submittal-templates'));
const SignUp = lazy(() => import('./sign-up'));
const TurnerPage = lazy(() => import('./turner'));
import PhoneCall from './PhoneCall';

import getQueryVariable from '../../../ui-components/js/getQueryVariable';

/* Dialogs { Forgot, Recover, EChange, About, Login } */
import { all as Dialogs, suspense } from '../../js/dialogs';

let page = '';
/* PublicWrapper */
function PublicWrapper(props) {
  useEffect(() => {
    let Dlg = Dialogs[props.dialog || ""];

    if (Dlg) {
      window.modal(suspense(Dlg), {routeParams: props.routeParams});
    }
  }, []);

  if (page !== props.page) {
    page = props.page;

    window.buildsite.logPageView();
    let container = document.querySelector('.mainWrapper');
    container && container.scroll(0, 0);
  }


  let MainClass = props.main;
  return (
    <>
      <PhoneCall />
      <Header page={props.page || ""} />
      <MainClass />
      <Footer />
    </>
  );
}

/* PublicContainer */
export default class PublicContainer extends React.Component {
  componentDidMount() {
    window.buildsite.logPageView();
    ["email_address", "redirect_url"].forEach(field => {
      let zz = getQueryVariable(field);
      if (zz) window.buildsite[field] = zz;
    });
    buildsite.api().on("refresh", this.goRefresh);
  }

  componentWillUnmount() {
    buildsite.api().removeListener("refresh", this.goRefresh);
  }

  goRefresh = () => {
    console.warn("PublicContainer got refresh event");
  }

  render() {
    return (
      <Suspense>
        <div className="mainWrapper">
          <Switch>
            <Redirect exact from="/" to="/home" />

            <Route path="/home"              render={() => <PublicWrapper page="home"              main={Home}  />} />
            <Route path="/login"             render={() => <PublicWrapper page="home"              main={Home}  dialog="Login" />} />
            <Route path="/interstitial"      render={() => <PublicWrapper page="home"              main={Home}  dialog="Interstitial" />} />
            <Route path="/sign-up"           render={() => <PublicWrapper page="sign-up"           main={SignUp} />} />
            <Route path="/emailchange/:id"   render={() => <PublicWrapper page="login"             main={Home} dialog="EChange" />} />
            <Route path="/recovery/:code/:type"    render={(p) => <PublicWrapper page="home"       main={Home} dialog="Recover" routeParams={p.match.params} />} />

            <Route path="/aboutus"           render={() => <PublicWrapper page="aboutus"           main={AboutUs}   />} />

            <Redirect exact from="/pricing/enterprise" to="/pricing" />


            <Route path="/pricing/:type"                      render={() => <PublicWrapper page="pricing"  main={Pricing}   />} />
            <Route path="/pricing"                      render={() => <PublicWrapper page="pricing"  main={Pricing}   />} />

            <Redirect exact from="/features" to="/gcs-owners" />
            <Route path="/gcs-owners"      render={() => <PublicWrapper page="gcs-owners"      main={GCOwner}  />} />
            <Route path="/gc-self-perform"     render={() => <PublicWrapper page="gc-self-perform"     main={GCSelfPerform}  />} />
            <Route path="/trade-contractors"     render={() => <PublicWrapper page="trade-contractors"     main={TradeContractor}  />} />
            <Route path="/suppliers"     render={() => <PublicWrapper page="suppliers"     main={Suppliers}  />} />
            <Route path="/small-business"     render={() => <PublicWrapper page="smallBusiness"     main={SmallBusiness}  />} />


            <Route path="/submittal-templates"   render={() => <PublicWrapper page="submittal-templates"  main={SubmittalTemplates} />} />
            <Route path="/tutorials"         render={() => <PublicWrapper page="tutorials"         main={Tutorials} />} />

            <Route path="/termsofuse"        render={() => <PublicWrapper page="terms"             main={TermsOfUse}        />} />
            <Route path="/privacypolicy"     render={() => <PublicWrapper page="policy"            main={PrivacyPolicy}     />} />
            <Route path="/customeragreement" render={() => <PublicWrapper page="customeragreement" main={CustomerAgreement} />} />
            <Route path="/dataformat"        render={() => <PublicWrapper page="dataformat"        main={DataFormat}        />} />
            <Route path="/contact"           render={() => <PublicWrapper page="contact"           main={Contact}           />} />
            <Redirect exact from="/sub-quick-start" to="/quick-start" />
            <Redirect exact from="/gc-quick-start" to="/quick-start" />
            <Route path="/quick-start"    render={() => <PublicWrapper page="quick-start"    main={QuickStart}        />} />
            <Route path="/intro/div-03-concrete"           render={() => <PublicWrapper page="concrete"              main={Concrete}       />} />
            <Route path="/intro/div-04-masonry"            render={() => <PublicWrapper page="masonry"               main={Masonry}        />} />
            <Route path="/intro/div-06-building-framing"   render={() => <PublicWrapper page="building-framing"      main={BuildingFraming}/>} />
            <Route path="/intro/div-07-roofing-insulation" render={() => <PublicWrapper page="roofing-insulation"    main={RoofingInsulation}/>} />
            <Route path="/intro/div-09-interior-specialty" render={() => <PublicWrapper page="interior-specialty"    main={InteriorSpecialty}/>} />
            <Route path="/intro/div-23-mechanical"         render={() => <PublicWrapper page="mechanical"            main={Mechanical}     />} />
            <Redirect exact from="/intro/misc" to="/intro/div-06-building-framing" />
            <Route path="/intro/turner"                    render={() => <PublicWrapper page="turner"                main={TurnerPage}     />} />

          </Switch>
        </div>
      </Suspense>
    );
  }
}
